export default {"src":"/_next/static/media/close.28c9e987.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};